
export function RATINGS_LOADING (state, status) {
  state['loading'] = status
}
export function RATINGS_SET_CURRENT (state, rating) {
  state['current'] = rating
}
